import EventEmitter from "./EventEmitter";
import Scene from '../index.js'
import * as THREE from 'three'

/* 
*   Keeps track of normalized mouse coordinates
*   Triggers custom event
*/

class Raycaster extends EventEmitter 
{

    constructor()
    {
        super()

        this.instance = new THREE.Raycaster()
        this.intersect = new THREE.Vector3()
        this.mouse = Scene.mouse
        this.camera = Scene.camera    

        // Events
        this.mouse.on('move', () => 
        {
            this.getIntersection()
        })
    }

    setObject(obj)
    {   
        this.obj = obj;
    }

    getIntersection()
    {
        if(this.obj)
        {
            this.instance.setFromCamera(new THREE.Vector2(this.mouse.x, this.mouse.y), this.camera.instance)
            this.intersection = this.instance.intersectObject(this.obj)

            if(this.intersection.length > 0)
            {
                this.trigger('intersect')
                this.intersect = this.intersection[0].point
            }
        }
    }
}

export default Raycaster